import { fetchApp, selectAppById } from "@app/deploy";
import {
  fetchDeploymentsByAppId,
  selectDeploymentsByAppId,
} from "@app/deployment";
import {
  fetchActivityById,
  idForTargetResourceType,
  selectFreezerActivityById,
} from "@app/freezer";
import { useQuery, useSelector } from "@app/react";
import { useParams } from "react-router-dom";
import { AppConfigView, Box, Group, tokens } from "../shared";

export function ActivityDetailConfigPage() {
  const { id = "" } = useParams();
  const activity = useSelector((s) => selectFreezerActivityById(s, { id }));
  useQuery(fetchActivityById({ id }));

  const appId =
    activity.primaryResourceType.toLowerCase() === "app"
      ? activity.primaryResourceId
      : (idForTargetResourceType(activity.targetResources, "app") ?? "");
  const operationId = activity.externalId ?? "";

  useQuery(fetchDeploymentsByAppId({ id: appId }));
  const deployments = useSelector((s) =>
    selectDeploymentsByAppId(s, { appId }),
  );
  const deployment = deployments.find((d) => d.operationId === operationId);

  useQuery(fetchApp({ id: deployment?.appId ?? appId }));
  const app = useSelector((s) =>
    selectAppById(s, { id: deployment?.appId ?? appId }),
  );

  if (!deployment) return null;

  const isCurrent = deployment.id === app.currentDeploymentId;
  const title = isCurrent
    ? "Current Configuration Variables"
    : "Previous Configuration Variables";

  return (
    <Box>
      <Group size="sm">
        <h3 className={tokens.type.h3}>{title}</h3>
        <AppConfigView
          configId={deployment.configurationId}
          envId={app.environmentId}
        />
      </Group>
    </Box>
  );
}
